import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ColorDefinition } from '../chrome-picker-selector';

@Component({
    selector: 'cw-input-color',
    templateUrl: './input-color.component.html',
    styleUrls: ['./input-color.component.scss'],
    standalone: false,
})
export class InputColorComponent {
    @Input() tag = '';

    @Input() value = 0;

    /* Indicates if the component is disabled */
    @Input() disabled = false;

    /* Indicates if the component is readonly */
    @Input() readonly = false;

    @Output() changeValue: EventEmitter<ColorDefinition> = new EventEmitter<ColorDefinition>();

    valueChange(e: EventTarget | null): void {
        this.value = parseInt((e as HTMLInputElement).value);
        if (this.value >= 256) {
            this.value = 255;
        }
        const color: ColorDefinition = { tagValue: this.tag, value: this.value };
        this.changeValue.emit(color);
    }

    limitInputCharacters(e: KeyboardEvent): boolean {
        return /Backspace|\d|Delete|ArrowLeft|Tab|Shift|ArrowRight/.test(e.key);
    }
}
